import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import {
  OsintPrintableDialogData,
  OsintSearchPrintableComponent,
} from './osint-search-printable.component';

/** Shared MatDialog options for the OSINT printable PDF preview. */
export function openOsintPrintableDialog(
  dialog: MatDialog,
  data: OsintPrintableDialogData,
): MatDialogRef<OsintSearchPrintableComponent> {
  return dialog.open(OsintSearchPrintableComponent, {
    data,
    panelClass: 'osint-printable-dialog-panel',
    backdropClass: 'osint-printable-dialog-backdrop',
    width: '96vw',
    maxWidth: '96vw',
    height: '94vh',
    maxHeight: '94vh',
    autoFocus: false,
    restoreFocus: false,
  });
}
